import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zhLang from 'element-ui/lib/locale/lang/zh-CN'

import PKG_JSON from "../../package.json"
import storage from "../../public/static/js/storage";

// 动态导入并合并所有 zh 目录下的 JSON 文件
const modules = require.context('./locales/zh', false, /\.json$/);
const zhLocal = {};

modules.keys().forEach(key => {
  const moduleContent = modules(key);
  // 将每个模块的内容合并到 zhLocal 对象中
  Object.assign(zhLocal, moduleContent);
});

const K_VERSION = PKG_JSON.version
const K_PROJECT_NAME = PKG_JSON.name

Vue.use(VueI18n)

function getGlobalStorageKeyName(key) {
    return K_PROJECT_NAME + "::" + K_VERSION + "::" + key;
}

// 获取当前语言设置，如果没有设置则默认为中文
const currentLocale = storage.get(getGlobalStorageKeyName('languageLocale')) || 'zh';

// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
    locale: currentLocale,
    messages: {
        'zh': {
            ...zhLang,     // Element UI 中文语言包
            ...zhLocal     // 本地中文翻译（已合并所有JSON文件）
        },
    },
    silentTranslationWarn: true,
})

window.i18n = i18n

export default i18n